module.exports = __webpack_public_path__ + "static/media/Postman.39894ce0.svg";